import axios, { AxiosResponse } from 'axios'
import { ID } from '../../../../../../_metronic/helpers'
import {
  RiscoAsoDtoCreate,
  RiscoAsoDtoUpdate,
  RiscoAsoView,
  RiscosClienteQueryResponse,
} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const RISCOS_CLIENTE_URL = `${API_URL}/empresas/cliente/risco`

/**
 * Busca todos os riscos de clientes
 * @param idEmpresa Identificador da empresa pai
 * @param query string
 * @returns RiscosClienteQueryResponse
 */
export const getRiscosCliente = (
  idEmpresa: ID,
  query: string
): Promise<RiscosClienteQueryResponse> => {
  return axios
    .get(`${RISCOS_CLIENTE_URL}?idEmpresa=${idEmpresa}&${query}`)
    .then((d: AxiosResponse<RiscosClienteQueryResponse>) => d.data)
}

/**
 * Busca um risco
 * @param idRisco Identificador de um risco
 * @returns RiscoAsoView
 */
export const getRiscoClienteById = (idRisco: ID): Promise<RiscoAsoView> => {
  return axios
    .get(`${RISCOS_CLIENTE_URL}/${idRisco}`)
    .then((response: AxiosResponse<RiscoAsoView>) => response.data)
}

/**
 * Cadastra um risco de um cliente
 * @param idEmpresaCliente Identificador da empresa cliente
 * @param risco RiscoAsoDtoCreate
 * @returns RiscoAsoView
 */
export const createRisco = (
  idEmpresaCliente: ID,
  risco: RiscoAsoDtoCreate
): Promise<RiscoAsoView> => {
  return axios
    .post(`${RISCOS_CLIENTE_URL}/${idEmpresaCliente}`, risco)
    .then((resp: AxiosResponse<RiscoAsoView>) => resp.data)
}

/**
 * Altera um risco de um cliente
 * @param idRisco Identificador do risco
 * @param risco RiscoAsoDtoUpdate
 * @returns RiscoAsoView
 */
export const editRisco = (idRisco: ID, risco: RiscoAsoDtoUpdate): Promise<RiscoAsoView> => {
  return axios
    .put(`${RISCOS_CLIENTE_URL}/${idRisco}`, risco)
    .then((resp: AxiosResponse<RiscoAsoView>) => resp.data)
}

/**
 * Remove um risco de um cliente
 * @param idRisco Identificador do risco
 * @returns void
 */
export const deleteRiscoCliente = (idRisco: ID): Promise<void> => {
  return axios.delete(`${RISCOS_CLIENTE_URL}/${idRisco}`).then(() => {})
}

/**
 * Remove riscos em lote. O backend não tem exclusão em lote: dispara uma requisição por id,
 * em paralelo, e rejeita se qualquer uma falhar.
 * @param riscoIds Identificadores dos riscos
 */
export const deleteLoteRiscosCliente = (riscoIds: Array<ID>): Promise<void> => {
  return Promise.all(riscoIds.map(deleteRiscoCliente)).then(() => {})
}
